import { AbstractField } from './AbstractField';
import isNil from 'lodash/isNil';
import { override, makeObservable } from 'mobx';
import { translate } from '@chaika/i18n/helper';

export interface OptionalTextFieldParams {
    isChecked: boolean;
    comment: string;
}

export class OptionalTextField extends AbstractField<OptionalTextFieldParams, OptionalTextFieldParams> {
    constructor(params: OptionalTextFieldParams, name: string) {
        super(params, name);
        makeObservable(this);
    }

    @override
    public get hasData(): boolean {
        return !isNil(this.fieldValue.isChecked);
    }

    public getPreview(): string {
        const { isChecked, comment } = this.fieldValue;

        return isChecked ? comment : translate('notChosen');
    }

    public makeUpdateParams(): OptionalTextFieldParams {
        return this.fieldValue;
    }

    public isEqual(value: OptionalTextFieldParams): boolean {
        const { isChecked, comment } = this.fieldValue;

        return isChecked === value.isChecked && comment === value.comment;
    }

    protected setDefaultValueValue(): void {
        this.defaultNullValue = {} as OptionalTextFieldParams;
    }

    protected setFieldValue(value: OptionalTextFieldParams): void {
        this.fieldValue = value;
    }
}
